import mscll from "@/api/mescrolls.js"; //工具
import MescrollVue from "mescroll.js/mescroll.vue";
import com from "@/api/common.js"; //工具
import notice from "@/api/notice.js"; //工具
export const loading = {
  data(){
    return {
      loading: false,
    }
  },
  watch:{
    loading(val){
      try{
        this.$root.$children[0].loading = val;
      }catch(e){
        console.log("loading写入异常");
      }
    }
  }
}
export const share = {
  methods:{
    openSharePanel(shareData, convert){
      if(convert){
        this.$http({
          type: "PUT",
          url: "/bplatTool/transformLongUrl",
          data: {
            url: shareData.link,
          }
        }).then(res =>{
          shareData.link = res.data;
          this.$app.openSharePanel(shareData);
        })
      }else{
        this.$app.openSharePanel(shareData);
      }
    },
    // convert是否需要转换短链接
    shareInit(shareData, convert){
      console.log(shareData)
      if(com.isApp){
        if(convert){
          this.$http({
            type: "PUT",
            url: "/bplatTool/transformLongUrl",
            data: {
              url: shareData.link,
            }
          }).then(res =>{
            shareData.link = res.data;
            this.$app.initShare(shareData);
          })
        }else{
          this.$app.initShare(shareData);
        }
      }else{
        this.$weixin.share(shareData);
      }
    }
  }
}
export const common = {
  mixins:[share],
  data(){
    return {
      loading: false,
      wxInfo:{},
      all: {
        POLICY_STATUS:{}
      },//字典数据
    }
  },
  watch:{
    loading(val){
      try{
        this.$root.$children[0].loading = val;
      }catch(e){
        console.log("loading写入异常");
      }
    }
  },
  methods:{
    checkLogin(url){
      // 在微信中验证是否绑定openid 或者token不存在跳转自动登录
      if(!localStorage.token) {
        if(url){
          sessionStorage.loginPage = url;
        }else{
          sessionStorage.loginPage = location.href;
        }
        this.$router.replace({path: "/m/login"});
        return false;
      }
      return true;
    },
    openFile(url,title,logo,content=""){
      // if(url.toLowerCase().indexOf(".pdf") != -1){
      //   location.href = "https://bx.wts999.com/m/pdf/viewer.html?file="+url;
      // }else{
      //   location.href = url;
      // }
      if(com.isApp){
        if(url.toLowerCase().indexOf(".pdf") != -1){
          this.$router.push({
            path: "/apps/fileView",
            query: {
              src:url,
              logo,
              title,
              shareText:content
            }
          });
          // this.$app.readPdf({url});
        }else{
          this.$notice.msg("暂只支持PDF文件预览");
        }
      }else{
        this.$router.push({
          path: "/apps/fileView",
          query: {
            src:url,
            logo,
            title,
            shareText:content
          }
        });
      }
    },
    goPage(url, params){
      this.$router.push({
        path: url,
        query: params
      });
    },
    jumpPage(url){
      location.href = url;
    },
    getBase(plat) {
      let base = "";
      if(plat == 'bplat'){
        if(this.$config.env==1){
          base = "https://www.fxyf99.com";
        }else{
          base = "https://fqyf.wts9999.net";
        }
      }else if(plat == 'fqjd'){
        if(this.$config.env==1){
          base = "https://jdstore.fxyf99.com";
        }else{
          base = "https://fqjdstore.wts9999.net";
        }
      }
      return base
    },
    jumpPageToken(plat,url) {
      const base = this.getBase(plat);
      location.href = base+'/m/product/BPSjump.html?policyManageToken='+localStorage.token+'&page='+encodeURIComponent(url);
    },
    setAllData(params={}){
      return new Promise((resolved,rejected)=>{
        if(sessionStorage.bdgj_allData) {
          try {
            this.all = JSON.parse(sessionStorage.bdgj_allData);
            resolved();
            return;
          } catch (error) {
            rejected();
            console.log("ALL数据解析异常");
          }
        }
        if(com.isApp) {
          this.$app.getSystemReadDic(params, res=>{
            if(res){
              try {
                if(params.type){
                  this.$set(this.all,params.type,JSON.parse(res))
                }else{
                  this.all = JSON.parse(res);
                }
                resolved();
              } catch (error) {
                rejected();
                console.log("all数据解析异常");
              }
            }
          },error=>{
            rejected();
            console.log("allError",error)
          })
        }else{
          this.$http({
            url:"/sys/dic/read/all",
            type:"GET",
          }).then(resData => {
            this.all = resData.data;
            sessionStorage.bdgj_allData = JSON.stringify(resData.data);
            resolved();
          });
        }
      })
    }
  }
}
export const pageTools = {
  data(){
    return {
      pageNum:1,
      pageSize:20,
      list:[],
      listUrl:"",
      listCount: 0,
      listLoading: false,
      finished: false,//是否加载完成
      finishedText: "暂无更多数据",
      listAll:true,
      timer:{},
    }
  },
  methods: {
    initListAjax(url) {
      this.listUrl = url;
      this.getListHttp();
    },
    // 搜索
    searchAjax(){
      // this.finishedText = "";
      this.finished = false;
      this.listLoading = true;
      // this.pageNum = 1;
      this.list = [];
      clearTimeout(this.timer);
      this.timer=setTimeout(_=>{
        this.getListHttp();
      },500)
    },
    // 设置自定义参数
    setListParams(params){},
    //请求回调
    listCallback(){},
    nextPage(){
      if(this.listUrl){
        this.pageNum++;
        this.getListHttp();
      }
    },
    // ajax请求
    getListHttp() {
      if(this.listAll){
        this.getListAll();
        return;
      }
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      this.setListParams(params);
      if (params.pageNum == 1) {
        this.list = [];
      }
      this.listLoading = true;
      this.$http({
        type: "PUT",
        url: this.listUrl,
        data: params
      }).then(resData => {
        this.listLoading = false;
        this.listCount = resData.total;
        const list = resData.data;
        if (params.pageNum > 1) {
          this.list = this.list.concat(list);
        } else {
          this.list = list;
        }
        if(this.list.length < this.listCount){
          this.finished = false;
          this.finishedText = ""
        }else{
          this.finished = true;
          this.finishedText = "暂无更多数据"
        }
        if(this.list.length==0){
          this.finished = true;
          this.finishedText = "";
        }
        this.listCallback(resData);
      });
    },
    // 无翻页列表
    getListAll(){
      const params = {}
      this.setListParams(params);
      this.list = [];
      this.listLoading = true;
      this.$http({
        type: "PUT",
        url: this.listUrl,
        data: params
      }).then(resData => {
        this.listLoading = false;
        this.list = resData.data;
        this.finished = true;
        if(this.list.length){
          this.finishedText = "暂无更多数据"
        }else{
          this.finishedText = ""
        }
        this.listCallback(resData);
      });
    }
  },
}
// 验证码倒计时
const CODE_SIZE = 60;
export const codeTools = {
  data(){
    return {
      CODE_SIZE,
      codeIndex: CODE_SIZE,
      timer:{},
    }
  },
  destroyed(){
    window.clearInterval(this.timer);
  },
  methods: {
    timerStart(){
      if(this.codeIndex!=CODE_SIZE) {
        return;
      }
      window.clearInterval(this.timer);
      this.codeIndex--;
      this.timer = window.setInterval(()=>{
        this.codeIndex--;
        if(this.codeIndex<=0) {
          window.clearInterval(this.timer);
          this.codeIndex = CODE_SIZE;
          return
        }
      },1000)
    },
    async getCodeAjax(mobile){
      const signNumber = await this.$tools.phoneSignature()
      if(!this.$regulars.isPhone(mobile)){
        this.$notice.msg("请输入正确的手机号")
        return;
      }
      this.timerStart();
      this.$http({
        type: "PUT",
        url: "/api/bplat/sendCode",
        data: {
          mobile: mobile,
          signature: signNumber,
        }
      }).then(res => {

      }).catch(e => {
        window.clearInterval(this.timer);
        this.codeIndex = CODE_SIZE;
      })
    }
  }
}
